// Auth context — holds the current user and exposes login/logout helpers.
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("hm_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/me");
      setUser(data);
    } catch {
      localStorage.removeItem("hm_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, userObj) => {
    localStorage.setItem("hm_token", token);
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("hm_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, loading, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
